import React from 'react';
import {StyledCard} from 'presentation/components';

export function AppointmentCardSkeleton() {
	return (
		<StyledCard.Container>
			<StyledCard.HeaderSkeleton />
			<StyledCard.FooterSkeleton />
		</StyledCard.Container>
	);
}
